// Mock API client.
// Today: resolves static data from src/data with a small delay so loading states behave
// like the real thing. Later: replace `respond` usages in the resource files with real
// HTTP calls (e.g. axios.get(`${API_BASE}/doctors/`)) — components will not need changes.

// export const API_BASE = process.env.REACT_APP_API_BASE || "";
export const API_BASE = (process.env.REACT_APP_API_BASE || "").replace(
  /\/$/,
  "",
);

// true when a backend URL is set in .env (REACT_APP_API_BASE). Empty = use the static data in src/data.
export const LIVE = Boolean(API_BASE);

// DRF error body -> one readable message
const errorMessage = (body, fallback) => {
  if (!body || typeof body !== "object") return fallback;
  const first = (v) =>
    Array.isArray(v)
      ? first(v[0])
      : v && typeof v === "object"
        ? first(Object.values(v)[0])
        : v;
  return first(body.detail ?? body) || fallback;
};

/** GET `${API_BASE}${path}` with query params. 404 -> NotFoundError. */
export async function apiGet(path, params = {}) {
  const url = new URL(API_BASE + path);
  Object.entries(params).forEach(
    ([k, v]) =>
      v !== undefined && v !== null && v !== "" && url.searchParams.set(k, v),
  );
  const res = await fetch(url);
  if (res.status === 404) throw new NotFoundError();
  if (!res.ok) throw new Error("Could not load data. Please try again.");
  return res.json();
}

/** POST JSON. Throws Error(message) with the server's validation message. */
export async function apiPost(path, body) {
  let res;
  try {
    res = await fetch(API_BASE + path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
  } catch {
    throw new Error("Could not send your request. Please call us instead.");
  }
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(
      res.status === 429
        ? "Too many requests. Please try again later or call us."
        : errorMessage(
            data,
            "Could not send your request. Please call us instead.",
          ),
    );
  }
  return data;
}

const MOCK_DELAY_MS = 150;

const clone = (value) =>
  value === undefined ? value : JSON.parse(JSON.stringify(value));

export function respond(data, delay = MOCK_DELAY_MS) {
  return new Promise((resolve) =>
    setTimeout(() => resolve(clone(data)), delay),
  );
}

export class NotFoundError extends Error {
  constructor(message = "Not found") {
    super(message);
    this.name = "NotFoundError";
    this.status = 404;
  }
}

export function respondOne(item, delay) {
  if (!item) return Promise.reject(new NotFoundError());
  return respond(item, delay);
}

export const byOrder = (a, b) => (a.order ?? a.id) - (b.order ?? b.id);
